import axios from "axios";
import { IP } from "../index";
// 查询所有用户积分纪录数据
export async function selectMoneyMiniRecord(data) {
  var resp = await axios.post(`${IP}/admin/moneyMiniRecord/select`, {
    ...data,
  });
  return resp.data;
}

// 查询所有用户积分纪录数据
export async function addOrReduceBalance(data) {
  var resp = await axios.post(`${IP}/admin/moneyMiniRecord/addOrReduceBalance`, {
    ...data,
  });
  return resp.data;
}